import React, { useReducer } from "react";
import { Button, Modal } from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";
import { server } from "../../../App";
import Viewer, { Worker } from "@phuocng/react-pdf-viewer";
import "@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css";
import { useSelector } from "react-redux";
import { selectPatientelleGrid } from "../../../features/patientelle/patientelleSlice";

function Note(props) {
  const PatientelleState = useSelector(selectPatientelleGrid);
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <>
      <Button

        style={{
          backgroundColor: "chartreuse",
          color: "black"
        }}
        onClick={() => dispatch({ type: ACTION.OPEN, size: "fullscreen" })}
      >
        Historique
      </Button>
      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
        className="lunettesModal"
      >
        <Modal.Content>
          <Worker workerUrl={`${server}DossierPDF/pdf.worker.min.js`}>
            <div style={{ height: "85vh" }}>
              <Viewer
                fileUrl={`${server}DossierPDF/${PatientelleState?.id_Magica}_Extraction.pdf`}
              />
            </div>
          </Worker>
        </Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={() => dispatch({ type: ACTION.CLOSE })}>
            Retour
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default Note;
